import React, {Component} from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../utils/api';

class Desvios extends Component {

  constructor(props) {
    super(props);
      this.state = {
        loader: ' loader-box',
        alertTitles: {
            1:"Precio Referencia Actual ($)",
            2:"Diferencial Actual (%)",
            3:"PVP Actual ($)",
            4:"PVP vs. Precio Referencia (%)",
            5:"Precio PM Actual ($)"
        },
        prodTitles: {},
        alerts: [],
        desvioId : this.props.desvioId ? this.props.desvioId : null,
        hasDesvioOpen : null
      };
      this.goToStation = this.goToStation.bind(this);
      this.editCluster = this.editCluster.bind(this);
      this.createSimulation = this.createSimulation.bind(this);
  }
    componentWillMount() {
        let _self = this;
        let prodTitles = {};
        api.get("dashboard/alerts").then(alerts => {
            let _alerts = [];
            alerts.data.forEach(el => {
                let obj = {
                    id: el.cluster.id,
                    cluster_name : el.cluster.name,
                    is_public : el.cluster.is_public,
                    is_core : el.cluster.is_core,
                    open : false,
                    station_issues : el.station_issues,
                    stations : []
                };

                el.stations.forEach(s => {
                    let station = {
                        inscription_number : "",
                        prices : {}
                    };

                    station.id = s.station.id;
                    station.inscription_number = s.station.inscription_number;
                    station.global_code = s.station.global_code;
                    station.prime_marker = s.prime_marker;

                    station.prices[_self.state.alertTitles[1]] = {};
                    station.prices[_self.state.alertTitles[2]] = {};
                    station.prices[_self.state.alertTitles[3]] = {};
                    station.prices[_self.state.alertTitles[4]] = {};
                    station.prices[_self.state.alertTitles[5]] = {};

                    s.prices.forEach(p => {
                        prodTitles[p.product_shortname] = 1;
                        station.prices[_self.state.alertTitles[1]][p.product_shortname] = p["reference_price"] !== null ? p["reference_price"].toFixed(2) : null;
                        station.prices[_self.state.alertTitles[2]][p.product_shortname] = p["diff_reference_price_vs_pm_pvp"] !== null ? p["diff_reference_price_vs_pm_pvp"].toFixed(2) : null;
                        station.prices[_self.state.alertTitles[3]][p.product_shortname] = p["pvp"] !== null ? p["pvp"].toFixed(2) : null;
                        station.prices[_self.state.alertTitles[4]][p.product_shortname] = p["diff_pvp_vs_reference_price"] !== null ? p["diff_pvp_vs_reference_price"].toFixed(2) : null;
                        station.prices[_self.state.alertTitles[5]][p.product_shortname] = p["pvp_pm"] !== null ? p["pvp_pm"].toFixed(2) : null;
                    });

                    obj.stations.push(station);
                });

                _alerts.push(obj);
            });

            _self.setState({
              alerts : _alerts,
              prodTitles: prodTitles,
              loader: ''
            });
        })
    }

    UNSAFE_componentWillReceiveProps(data){
        let _self = this;
        let _state = _self.state;
        let _alerts = _state.alerts;
        let desvioId = data.desvioId;
        let hasDesvio = false;
        if(desvioId) {
            if (_alerts && desvioId !== undefined && desvioId !== null) {
                _alerts.forEach(a => {
                    a.open = desvioId === a.id;
                    hasDesvio |= a.open;
                })
            }

            if(hasDesvio) {
                $('html, body').animate({
                    scrollTop: $("#desviosTable").offset().top
                }, 800, function() {
                  var container = $('#desviosTable'), scrollTo = $('#cluster_' + desvioId);
                  container.animate({
                      scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop() - (scrollTo.outerHeight()  + 5)
                  }, 800);
                });
            }
            else{
              toast.error("El cluster no tiene alertas");
            }
        }
    }

    goToStation(station) {
      window.location = '/analisis/estacion/' + station.id
    }

    editCluster(id){
      window.location = '/analisis/cluster/editar/'+id
    }

    createSimulation(cluster_id, cluster_name){
        window.location = '/simulador/' + cluster_id + '/' + cluster_name;
    }

  render() {
    let _self = this;
    let _user = _self.props.user;
    return <div className="dashboard_desvios">
              <ToastContainer />
              <div className="row">
                  <div className="col s12">
                      <div className="dashboard_precios_title">
                          <div className="row">
                              <div className="col s12">
                                  <h2>ALERTAS DE DESVÍOS ({_self.state.alerts.length})</h2>
                              </div>
                          </div>
                      </div>
                      <div id="desviosTable" name="desviosTable" className={"dashboard_desvios_content" + this.state.loader}>
                          <div className="dashboard_desvios_content_title">
                              <div className="dashboard_desvios_content_location-cluster_boca">
                                  <div className="nro-boca">
                                  </div>
                                  <div className="fila-boca active-pump">
                                      <div className="fila-boca_1">
                                          <span className="fila-boca_title"></span>
                                          {Object.keys(_self.state.prodTitles).map(k => {
                                              return <span key={k} className="fila-boca_prod">{k}</span>
                                          })}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          {_self.state.alerts.map((alert, i) => {
                              return <div key={i}>
                                  <div id={'cluster_'+ alert.id} name={'cluster_'+ alert.id} className={'dashboard_desvios_content_location-cluster' + (alert.open ? ' active-cluster' : '')}>
                                      <div className="row">
                                          <div className="col s6">
                                              <i className={alert.is_core ? 'fas fa-star' : 'fa fa-fw'}></i>
                                              <div className="img-angle" onClick={() => { alert.open = !alert.open;  _self.setState({clusters: _self.state.alerts}) } }>
                                                  <img alt="" src="/static/imgs/angle-right.svg" />
                                              </div>
                                              <div className="dashboard_desvios_content_location-cluster_loc-name">
                                                  <span>{alert.cluster_name}</span>
                                              </div>
                                              <div className="dashboard_desvios_content_location-cluster_pumps-numb right">
                                                  <span className="number">{_self.state.alerts[i].station_issues}</span>
                                                  <span className="text">Bocas con desvios</span>
                                              </div>
                                          </div>
                                          <div className="col s6 cluster-btns">
                                              {_user && ((alert.is_public && _user.canModifyPublic) || (!alert.is_public && _user.canModifyPrivate)) ? <span onClick={() => { _self.editCluster(alert.id) } } className="desvio-cluster-btn">Editar Cluster</span> : ""}
                                              {_user && _user.canSeeSimulator ? <span onClick={() => { _self.createSimulation(alert.id, alert.cluster_name)} } className="desvio-cluster-btn">Simular</span> : ""}
                                          </div>
                                      </div>
                                  </div>
                                  {alert.stations.map((boca, x) => { 
                                      return <div key={x} className={'dashboard_desvios_content_location-cluster_boca' + (alert.open ? ' show-on-medium-and-up' : '')}>
                                          <div className="nro-boca">
                                              <div className="img-angle" onClick={ () => { boca.active = !boca.active;  _self.setState({clusters: _self.state.alerts}) } }>
                                                  <img alt="" src="/static/imgs/angle-right.svg" />
                                              </div>
                                              <span onClick={() => { _self.goToStation(boca) } }>{boca.global_code}</span>
                                              {boca.active && <span className="brand" onClick={() => { _self.goToStation(boca.prime_marker) } }>{(boca.prime_marker.brand.name ? boca.prime_marker.brand.name : '') + ' ' + boca.prime_marker.inscription_number}</span>}
                                          </div>
                                          <div className={'fila-boca' + (boca.active ? ' active-pump' : '')}>
                                              {Object.keys(_self.state.alertTitles).map(id => {
                                                  return <div key={id} className={"fila-boca_"+id}>
                                                      <span className="fila-boca_title">{_self.state.alertTitles[id]}</span>
                                                      {Object.keys(_self.state.prodTitles).map(k => {
                                                          return <span key={k} className="fila-boca_prod">{boca.prices[_self.state.alertTitles[id]][k]}</span>
                                                      })}
                                                  </div>
                                              })}
                                          </div>
                                      </div>
                                  })}
                              </div>
                          })}
                      </div>
                  </div>
              </div>
          </div>
  }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Desvios);


// WEBPACK FOOTER //
// ./src/containers/dashboard/desvios.js